import React, { VFC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useTheme, Theme } from '@material-ui/core/styles';
import LogoTextImage from '../../../../shared/images/icons/logo-text.png';

const Img = styled.img<{ theme: Theme }>`
  width: 135px;
  height: auto;
  margin-right: ${({ theme }) => theme.spacing(2)};
  vertical-align: middle;
  border-style: none;
`;

interface Props {}
const PCLogo: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return <Img src={LogoTextImage} alt={t('otetsutabi')} theme={theme} />;
};

export default PCLogo;
